import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "details-stack" }
const _hoisted_2 = { class: "doc-field" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "field-error"
}
const _hoisted_6 = { class: "doc-field" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "field-error"
}

import { ref, watch, onBeforeUnmount, toRefs } from "vue";

type DocumentKey = "id_front" | "id_back";


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentsForm',
  props: {
    id_front: { default: null },
    id_back: { default: null },
    errors: { default: () => ({}) }
  },
  emits: ["update:id_front", "update:id_back"],
  setup(__props: any, { emit: __emit }) {

const idFrontInput = ref<HTMLInputElement | null>(null);
const idBackInput = ref<HTMLInputElement | null>(null);

const props = __props;

const { id_front, id_back, errors } = toRefs(props);

const emit = __emit;

// Local client-side errors (e.g., invalid file type)
const localErrors = ref<{ id_front?: string; id_back?: string }>({});

// Object URL previews for image files
const previews = ref<{ id_front: string | null; id_back: string | null }>({
  id_front: null,
  id_back: null,
});

function getError(key: DocumentKey) {
  // prefer local validation errors, fall back to parent-provided errors
  return localErrors.value[key] || (errors.value && (errors.value as any)[key]);
}

function isImageFile(file: File) {
  // Some browsers can return an empty mime type; fall back to extension.
  if (file.type) return file.type.startsWith("image/");
  return /\.(png|jpe?g|webp|gif|bmp|heic|heif)$/i.test(file.name);
}

function setPreview(key: DocumentKey, file: File | null) {
  const current = previews.value[key];
  if (current) URL.revokeObjectURL(current);
  previews.value[key] = file ? URL.createObjectURL(file) : null;
}

function pick(key: DocumentKey) {
  if (key === "id_front") idFrontInput.value?.click();
  if (key === "id_back") idBackInput.value?.click();
}

function onChange(event: Event, key: DocumentKey) {
  const input = event.target as HTMLInputElement | null;
  const file = input?.files?.[0] || null;

  if (file && !isImageFile(file)) {
    // reject non-image files
    localErrors.value[key] = "Only image files are allowed (jpg, png, gif, etc.)";
    // clear selection in input
    if (input) input.value = "";
    // inform parent we didn't accept the file
    if (key === "id_front") emit("update:id_front", null);
    if (key === "id_back") emit("update:id_back", null);
    setPreview(key, null);
    return;
  }

  // clear any previous local error
  localErrors.value[key] = undefined;

  // emit the chosen file (may be null)
  if (key === "id_front") emit("update:id_front", file);
  if (key === "id_back") emit("update:id_back", file);

  // update preview immediately (don't wait on parent prop update)
  setPreview(key, file);

  // clear native input so same file can be re-selected later
  if (input) input.value = "";
}

// Create and manage previews when parent updates the files
watch(id_front, (newVal) => {
  if (newVal && isImageFile(newVal as File)) setPreview("id_front", newVal as File);
  else setPreview("id_front", null);
});

watch(id_back, (newVal) => {
  if (newVal && isImageFile(newVal as File)) setPreview("id_back", newVal as File);
  else setPreview("id_back", null);
});

onBeforeUnmount(() => {
  if (previews.value.id_front) URL.revokeObjectURL(previews.value.id_front);
  if (previews.value.id_back) URL.revokeObjectURL(previews.value.id_back);
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "doc-header" }, "Driving License / Passport (Front)", -1)),
        _createElementVNode("input", {
          ref_key: "idFrontInput",
          ref: idFrontInput,
          type: "file",
          class: "file-input",
          accept: "image/*",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (onChange($event, 'id_front')))
        }, null, 544),
        _createVNode(_component_v_btn, {
          variant: "outlined",
          "prepend-icon": "mdi-upload",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (pick('id_front')))
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" Choose File ", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          (previews.value.id_front)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: previews.value.id_front,
                class: "file-preview"
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["file-name", { 'has-error': getError('id_front') }])
          }, _toDisplayString(_unref(id_front)?.name || "No file selected"), 3)
        ]),
        (getError('id_front'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(getError("id_front")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "doc-header" }, "Driving License / Passport (Back)", -1)),
        _createElementVNode("input", {
          ref_key: "idBackInput",
          ref: idBackInput,
          type: "file",
          class: "file-input",
          accept: "image/*",
          onChange: _cache[2] || (_cache[2] = ($event: any) => (onChange($event, 'id_back')))
        }, null, 544),
        _createVNode(_component_v_btn, {
          variant: "outlined",
          "prepend-icon": "mdi-upload",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (pick('id_back')))
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" Choose File ", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          (previews.value.id_back)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: previews.value.id_back,
                class: "file-preview"
              }, null, 8, _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["file-name", { 'has-error': getError('id_back') }])
          }, _toDisplayString(_unref(id_back)?.name || "No file selected"), 3)
        ]),
        (getError('id_back'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(getError("id_back")), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})